import { render, staticRenderFns } from "./aboutCenGywm.vue?vue&type=template&id=01c2ed4c&scoped=true"
import script from "./aboutCenGywm.vue?vue&type=script&lang=js"
export * from "./aboutCenGywm.vue?vue&type=script&lang=js"
import style1 from "./aboutCenGywm.vue?vue&type=style&index=1&id=01c2ed4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2ed4c",
  null
  
)

export default component.exports